import apiService from '../Api'
import {
  IAdmissionCreateResponseRaw,
  IAdmissionDocumentRaw,
  IAdmissionDraftRaw,
  IAdmissionOptionsRaw,
  IAdmissionSaveResponseRaw
} from './types'

/** The public admission form (ABRA-320). Every call but `options` and `create` is scoped by the draft's token. */
export class AdmissionService {
  async options(): Promise<IAdmissionOptionsRaw> {
    return apiService.get('/admission/options').then((response) => response.data)
  }

  /** The first step creates the draft and returns its token (the resume link). */
  async create(data: FormData): Promise<IAdmissionCreateResponseRaw> {
    return apiService.post('/admission', data).then((response) => response.data)
  }

  async get(token: string): Promise<IAdmissionDraftRaw> {
    return apiService.get(`/admission/${token}`).then((response) => response.data.draft)
  }

  async save(token: string, data: FormData): Promise<IAdmissionSaveResponseRaw> {
    data.append('_method', 'PUT')
    return apiService.post(`/admission/${token}`, data).then((response) => response.data)
  }

  async usernames(token: string): Promise<string[]> {
    return apiService.get(`/admission/${token}/usernames`).then((response) => response.data.usernames)
  }

  async uploadDocument(token: string, documentId: number, file: File): Promise<IAdmissionDocumentRaw> {
    const data = new FormData()
    data.append('file', file)
    return apiService
      .post(`/admission/${token}/documents/${documentId}`, data)
      .then((response) => response.data.document)
  }

  async deleteDocument(token: string, documentId: number): Promise<void> {
    return apiService.delete(`/admission/${token}/documents/${documentId}`).then(() => undefined)
  }

  async submit(token: string): Promise<void> {
    return apiService.post(`/admission/${token}/submit`).then(() => undefined)
  }
}
